import React, { Component } from 'react'
import $ from 'jquery'

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import {
    addModal,
    popModal
} from '../../../actions/appAction'

import {
    translate
} from 'react-switch-lang'

export class UserChooser extends Component {

    constructor(){
        super();
        this.state = {
            emailAddress : "",
            emailInvalid : false,
            modalZ : 1050
        }
    }

    componentDidMount(){
       
        const { isOpened } = this.props;
        
        if(isOpened){
            $('#userChooserModal').modal({backdrop:'static', keyboard:false});
            $('#userChooserModal .modal-dialog').attr('class','modal-dialog modal-dialog-centered slideInDown animated')
            $('#userChooserModal').modal('show');
            if(this.props.addModal){
                this.props.addModal('user-chooser-modal')
            }
            $('.modal-backdrop').eq($('.modal-backdrop').length-1).addClass("uc-bd");
        }

    }

    componentDidUpdate(prevProps){
        if(prevProps.modalInstances!==this.props.modalInstances){
            let modalInstance = this.props.modalInstances.find( (data) => data.modal_class==="user-chooser-modal");
            if(modalInstance!==undefined){
                $('.uc-bd').css('z-index',`${modalInstance.z_index-10}`)
                this.setState({
                    modalZ : modalInstance.z_index
                })
            }
        }
    }

    componentWillUnmount(){
        $('#userChooserModal').modal('hide');
        if(this.props.popModal){
            this.props.popModal()
        }
        $('body').removeClass('modal-open');
    }

   
    render(){
        const { modalZ } = this.state;

        const { isMobileView } = this.props;
        const { t, currentLanguage } = this.props;

        let modalDialogClass = isMobileView ? "mobile-modal" : "" 

        return (
            <div style={{ zIndex : `${modalZ}` }} className={`${modalDialogClass} user-chooser-modal modal fade modal-opaque`} id="userChooserModal" tabIndex="-1" role="dialog" aria-labelledby="userChooserModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {
                            isMobileView ?
                            <div className="mobile-custom-header modal-header" style={{ boxShadow : "unset" }}>
                                <div className="row" style={{ width: "100%" }}>
                                    <div className="col" style={{ textAlign : "left" }}>
                                        <img style={{ display: "block", width: "150px" }} src={require('../../../images/tarjemle-logo.png')}/>
                                    </div>
                                    <div className="col" style={{ textAlign : "right", paddingRight : "0" }}>
                                        <button onClick={this.props.closeUserChooserModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="custom-modal-header modal-header">
                                <button onClick={this.props.closeUserChooserModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span style={{ fontWeight: "300", fontSize: "70px" }} aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        }
                        <div className="modal-body">
                            <p style= {{ margin : "0 auto", width : isMobileView ? "100%" : "50%" }} className="text-header">{t('login_message_user_chooser_header')}</p>
                            <div style={{ display : "flex" }} className="mt-3">
                                <div style= {{ flex : "1" }}>
                                    <button onClick={ () => this.props.selectUserType('customer') } className="user-chooser-btn">{t('common_customer')}</button>
                                </div>
                                <div style= {{ flex : "1" }}>
                                    <button onClick={ () => this.props.selectUserType('translator') } className="user-chooser-btn">{t('common_word_translator')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        )

    }

}

const mapStateToProps = state => {
    return {
        modalInstances : state.app.modalInstances,
        isMobileView : state.app.isMobileView
    }
}

export default compose(
    withRouter,
    translate,
    connect(mapStateToProps, { 
        addModal,
        popModal
    })
)(UserChooser)